import { useContext, useRef } from "react";
import { AvatarContext } from "../../context/AvatarContext";

export const useAvatarSession = (headers) => {
    const context = useContext(AvatarContext);
    if (!context) { throw new Error("useAvatarSession must be used within an AvatarProvider") }
    const {
        avatar,
        avatarReady,
        isVideoLoading,
        heygenError,
        init,
        restartLiveAvatarSession,
        stop,
        speak,
        processPayment,
        audioElsRef,
        videoLayerRef,
        isSmallScreen,
        setIsSmallScreen,
        hasVideo, setHasVideo,
        activeConsultationId, setActiveConsultationId
    } = context;

    return {
        avatar,
        avatarReady,
        isVideoLoading,
        heygenError,
        init: () => init(headers),
        restartLiveAvatarSession: () => restartLiveAvatarSession(headers),
        stop,
        speak,
        processPayment,
        videoLayerRef,
        audioElsRef,
        isSmallScreen,
        setIsSmallScreen,
        hasVideo, setHasVideo,
        activeConsultationId, setActiveConsultationId
    };
};